import { maxBreakpoints, minBreakpoints } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
export var mobileButtons = /*#__PURE__*/css(["display:none;", ";"], mediaQuery({
  max: maxBreakpoints.M
}, css(["display:flex;width:", ";justify-content:space-between;margin:0 auto;"], pxToRem(280))));
export var link = /*#__PURE__*/css(["display:block;"]);
export var button = /*#__PURE__*/css(["display:none;", ";"], mediaQuery({
  min: minBreakpoints.L
}, css(["display:inline-block;"])));